import { useAppSelector } from '../../../Hooks/useAppSelector'
import { ShipmentItemsSelectors } from '../StoreAdapter'

export const useShipmentItemSelector = (entityId: string) => {
  const entityState = useAppSelector((state) =>
    ShipmentItemsSelectors.selectById(state, entityId),
  )

  return entityState
}
